import React from 'react';
import { displayMessage, displayCreateEventError, SILENT_EVENT_UPDATE } from './wsHelpers';
import SubscriptionTemplate from './SubscriptionTemplate';
import {
	recordCreatedEvent,
	recordDeletedEvent,
	updateEvent,
	undeleteEvent,
	updateClient,
	deleteAttendee,
} from '@/redux/actions';
import { connect } from 'react-redux';

const SOCKET_EVENTS_BY_HTTP = {
	EVENT_PATCH: 'event/:eventID/PATCH',
	EVENT_DELETE: 'event/:eventID/DELETE',
	EVENT_POST: 'event/POST',
	EVENT_UNDELETE: 'event/:eventID/undelete/PATCH',
	CLIENT_PATCH: 'client/:clientID/PATCH',
	DELETE_ATTENDEE: 'attendee/:attendeeID/DELETE',
};

const ClientSubscriptions = props => {
	const {
		socket,
		currentClient,
		recordCreatedEvent,
		updateEvent,
		undeleteEvent,
		recordDeletedEvent,
		updateClient,
		deleteAttendee,
		adminSSOProfile,
		route,
		children,
	} = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToClient = () => {
		socket.emit('client/:clientID/SUBSCRIBE', { clientID: currentClient.id });
		if (adminSSOProfile) {
			socket.emit('admin/:adminEmail/SUBSCRIBE', { email: adminSSOProfile.email });
		}
	};

	const unsubscribeToClient = () => {
		socket.emit('client/:clientID/UNSUBSCRIBE', { clientID: currentClient.id });
		if (adminSSOProfile) {
			socket.emit('admin/:adminEmail/UNSUBSCRIBE', { email: adminSSOProfile.email });
		}
	};

	const listenForCreatedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_POST, payload => {
			const { data, error } = payload;
			if (error) {
				displayCreateEventError(error);
				return;
			}
			// the creator's ack lands before this broadcast and already recorded and toasted the event
			if (recordCreatedEvent(data)) displayMessage('Event created');
		});

	const listenForUpdatedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_PATCH, payload => {
			const { data, error, from } = payload;
			if (error) displayMessage('Event could not be updated', error);
			else {
				updateEvent(data);
				if (from !== SILENT_EVENT_UPDATE) displayMessage('Event updated');
			}
		});

	const listenForUndeletedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_UNDELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Event could not be unarchived', error);
			else {
				undeleteEvent(data);
				displayMessage('Event unarchived');
			}
		});

	const listenForDeletedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Event could not be deleted', error);
			else {
				recordDeletedEvent(data);
				displayMessage('Event Archived');
			}
		});

	const listenForUpdatedClient = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.CLIENT_PATCH, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Client could not be updated', error);
			else {
				updateClient(data);
				displayMessage('Client updated');
			}
		});

	const listenForDeletedAttendee = () => {
		socket.on(SOCKET_EVENTS_BY_HTTP.DELETE_ATTENDEE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Account could not be deleted', error);
			else {
				deleteAttendee({ attendeeID: data.id });
				displayMessage('Account deleted');
			}
		});
	};
	const listeners = () =>
		route === '/events/'
			? [
					listenForCreatedEvent,
					listenForUpdatedEvent,
					listenForDeletedEvent,
					listenForUndeletedEvent,
					listenForUpdatedClient,
			  ]
			: route === '/accounts/'
			? [listenForDeletedAttendee]
			: [listenForUpdatedClient];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToClient}
				unsub={unsubscribeToClient}
				listeners={listeners()}
				routes={Object.values(SOCKET_EVENTS_BY_HTTP)}
				from="ClientSubscriptions"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ auth, ws, clients }) => ({
	adminSSOProfile: auth.adminSSOProfile,
	socket: ws.socket,
	currentClient: clients.currentClient,
});

const mdp = dispatch => ({
	recordCreatedEvent: event => dispatch(recordCreatedEvent(event)),
	updateEvent: event => dispatch(updateEvent(event)),
	recordDeletedEvent: event => dispatch(recordDeletedEvent(event)),
	undeleteEvent: event => dispatch(undeleteEvent(event)),
	updateClient: client => dispatch(updateClient(client)),
	deleteAttendee: attendeeID => dispatch(deleteAttendee(attendeeID)),
});

export default connect(msp, mdp)(ClientSubscriptions);
